module.exports = __webpack_public_path__ + "img/final_star.34e9a386.png";